(function(angular){
	'use strict';
	
	angular.module('riskAdjustedReturnModule', [
		'coreModule',
		'reitElementListingModule'
	]);

})(window.angular);